// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".enter[data-v-37c64695]{border:5px solid #00808a}", "",{"version":3,"sources":["/Users/niwashouta/projects/kgi_sfa/app/javascript/erp_src/view/shared/MatterFilesTable.vue"],"names":[],"mappings":"AAEA,wBACC,wBAAA","file":"MatterFilesTable.vue","sourcesContent":["\n@import \"../../stylesheet/variable.scss\";\n.enter {\n\tborder: 5px solid $sub-color;\n}\n"]}]);
// Exports
module.exports = exports;
